import { useMemo } from 'react';

import MultiSelectTagPicker from '@shared/components/MultiSelectTagPicker';

import type { TSparseItem } from '@modules/items';

type TProps = {
  options: TSparseItem[];
  selectedRootIds: string[];
  onChange: (rootIds: string[]) => void;
  className?: string;
};

const DashboardFilterPicker = ({ options, selectedRootIds, onChange, className }: TProps) => {
  const pickerOptions = useMemo(
    () =>
      options.map((root) => ({
        value: root._id,
        label: root.name,
        searchText: root.name,
      })),
    [options]
  );

  return (
    <MultiSelectTagPicker
      options={pickerOptions}
      selectedOptions={selectedRootIds}
      onChange={onChange}
      inputAriaLabel="Select products and Quality management"
      selectedAriaLabel="Selected products and Quality management"
      noMatchesMessage="No matching option."
      placeholder="All"
      unknownOptionLabel="Unknown option"
      className={className}
      variant="summary"
    />
  );
};

export default DashboardFilterPicker;
